import { ShoppingCartOutlined } from '@mui/icons-material';
import { useContext, useEffect, useState } from 'react';
import { OrderContext, OrderContextProvider } from '../ContextApi/context';
import MyOrderOnCart from '../web_pages/RestaurantPage/ForOrderOptions/myOrderOnCart';

const ShopingCartFloat = (props) => {
    const [order, setOrder] = useContext(OrderContext);

    const [counter, setCounter] = useState(0);

    const [showCart, setShowCart] = useState(false);

    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        let coun = 0;

        order.Orders?.forEach(item => {
            coun = parseInt(coun) + parseInt(item.mount);
        });
        setCounter(coun)

        // אם הסל ריק, נסגור אותו אוטומטית
        if (coun === 0 && showCart) {
            setShowCart(false);
        }

    }, [order])

    useEffect(() => {
        if (showCart) {
            document.body.classList.add('cart-open');
            setIsAnimating(true);
        } else {
            document.body.classList.remove('cart-open');
            if (isAnimating) {
                setTimeout(() => {
                    setIsAnimating(false);
                }, 300); // זמן האנימציה
            }
        }
        return () => {
            document.body.classList.remove('cart-open');
        };
    }, [showCart])

    return (
        <>
            {/* כפתור הסל */}
            <div className={"shopCartBtnWrap"} onClick={() => setShowCart(!showCart)} >
                <ShoppingCartOutlined sx={{ fontSize: 30 }} /><span>{counter}</span>
            </div>

            {/* שכבת החשכה - מופיעה רק כשהסל פתוח */}
            {(showCart || isAnimating) && (
                <div
                    className={`cartOverlay animate__animated ${showCart ? 'animate__fadeIn' : 'animate__fadeOut'} animate__faster`}
                    onClick={() => setShowCart(false)}
                />
            )}

            {/* הסל עצמו */}
            {(showCart || isAnimating) && (
                <div className={`shopCartFloatDiv ${showCart  ? '' : 'hideShopCart'}`}>
                    <MyOrderOnCart
                        continToPay={() => props.continToPay()}
                        theOrder={order}
                        counter={counter}
                        setShowCart={() => setShowCart(!showCart)}
                    />
                </div>
            )}
        </>

    )

}
export default ShopingCartFloat;